

















import Vue from "vue";
import { Announcement } from "@/api/dto/Announcement";
import { getAnnouncement } from "@/api/Announcement";
import { formatDate } from "@/utils/momentUtils";

interface Data {
  announcement: Announcement;
}

export default Vue.extend({
  name: "AnnouncementsDetail",
  async beforeRouteEnter(to, from, next) {
    try {
      const res = await getAnnouncement(to.params.id);
      next(vm => (vm.$data as Data).announcement = res);
    } catch (e) {
      next({ name: 'Top' });
    }
  },
  data(): Data {
    return {
      announcement: {} as Announcement,
    };
  },
  filters: {
    formatDate,
  },
});
